import { useState, useRef } from "react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { useNavigate } from "react-router-dom";
import Help from "./Help";
import swal from "sweetalert";
import { languages } from "./Langs";

//https://sweetalert.js.org/guides/

const ZOOMMAX = 200;
const ZOOMNORM = 100;
const ZOOMINC = 50; //increment

const Navbar = (props) => {
  const [lang, setLang] = props.lang;

  let zoom = props.zoom;
  const setScrollY = props.setScrollY;
  const setZoom = props.setZoom;
  const setOpenHelp = props.setOpenHelp;
  const openHelp = props.openHelp;
  const showButtons = !props.disableToolBar;
  const color = props.color ?? "#0a213c";
  const helpColor = props.helpColor ?? "#fff";
  const bannerId = props.banner ?? 0;
  const canSubmit = props.canSubmit;
  const getNextId = props.getNextId;
  const fields = props.fields;
  const submit = props.submit;

  const [f, sf] = useState(0);

  const style = {
    backgroundColor: `${color}`,
    boxShadow: "1px 5px 5px rgba(1, 1, 1, 0.5)",
  };

  //const bannerUrls = ["../shs.png", "../ssi.png", "../sga.png"];
  // Generic branding
  const bannerUrls = ["../safesign163.png", "../safesign163.png", "../safesign163.png"];
  
  const logo = bannerUrls[bannerId].replace(".png", "").replace("../", "");
  const getSubmit = props.getSubmit;

  return (
    <div id="navbar" style={style}>
      <img
        src={bannerUrls[bannerId]}
        alt="help"
        id="logo"
        className={`${logo}`}
      />

      {showButtons ? (
        <>
          <a
            className="navbtn"
            onClick={() => {
              // find next id to go to
              if (!canSubmit(fields)) {
                const nextId = getNextId(fields);
                if (nextId > -1) {
                  document.location.hash = `loc${Number(nextId) + 1}`;
                }
              } else {
                swal({
                  title: lang.AllGoodToSubmit,
                  text: lang.AllLocations,
                  buttons: {
                    cancel: lang.GoBack,
                    submit: {
                      text: lang.Submit,
                      value: "submit",
                    },
                  },
                  icon: "success",
                }).then((res) => {
                  if (res === "submit") {
                    submit();
                  }
                });
              }

              sf(0); //force refresh
            }}
            style={{
              paddingTop: "8px",
              paddingBottom: "8px",
            }}
          >
            <span>{lang.Next}</span>
          </a>
          <a
            className="navbtn"
            id="mobileremove1"
            onClick={(ref) => {
              zoom += ZOOMINC;
              if (zoom > ZOOMMAX) {
                zoom = ZOOMMAX;
              }
              setScrollY(window.scrollY);
              setZoom(zoom);
            }}
          >
            <ZoomInIcon></ZoomInIcon>
          </a>
          <a
            className="navbtn"
            id="mobileremove2"
            onClick={() => {
              zoom -= ZOOMINC;
              if (zoom < ZOOMNORM) {
                zoom = ZOOMNORM;
              }
              setScrollY(window.scrollY);
              setZoom(zoom);
            }}
          >
            <ZoomOutIcon></ZoomOutIcon>
          </a>
          <a
            className="navbtn"
            id="submit"
            style={{
              paddingTop: "8px",
              paddingBottom: "8px",
            }}
            onClick={async () => {
              // find next id to go to
              if (!canSubmit(fields)) {
                await swal({
                  text: lang.LookOver,
                  title: lang.MissingLocation,
                  icon: "warning",
                });
              } else {
                await submit();
              }
            }}
          >
            {lang.Submit}
          </a>
        </>
      ) : null}

      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.13.0/css/all.css"
        integrity="sha384-Bfad6CLCknfcloXFOyFnlgtENryhrpZCe29RTifKEixXQZ38WheV+i/6YWSzkz3V"
        crossOrigin="anonymous"
      />

      <span
        style={{
          position: "fixed",
          right: "0",
          top: "0",
          marginTop: "12px",
          marginRight: "20px",
          marginLeft: "20px",
          zIndex: 1,
        }}
      >
        <div
          className="hide-lang"
          style={{
            float: "left",
            margin: "0px 15px 0px 15px",
            padding: "0",
          }}
        >
          <div>
            <select
              style={{
                display: "inline",
                position: "relative",
                marginLeft: "10px",
                marginRight: "10px",
                // left: "50%",
                // top: "10px",
                // transform: "translate(-50%, -50%)",
              }}
              onChange={(v) => {
                setLang(
                  languages[v.target.options[v.target.selectedIndex].value]
                );
                v.target.selectedIndex = 0;
              }}
              name="lang"
              id="langSelect"
            >
              <option id="selectedLang" value="none" hidden>
                {lang.Language}
              </option>
              <option value="en">{lang.English}</option>
              <option value="es">{lang.Spanish}</option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="bi bi-globe"
              viewBox="0 0 16 16"
              style={{
                color: helpColor,
              }}
            >
              <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z" />
            </svg>
          </div>
        </div>
        <a
          onClick={() => {
            setOpenHelp(true);
          }}
          style={{ color: helpColor, fontSize: "18px" }}
        >
          {lang.Help}
          <i
            className="fa fa-question-circle"
            style={{
              fontSize: "24px",
              marginLeft: "10px",
              paddingTop: "2px",
              marginTop: "1px",
              float: "right",
            }}
          ></i>
        </a>
      </span>

      <Help
        lang={lang}
        modal
        openHelp={openHelp}
        setOpenHelp={setOpenHelp}
      ></Help>
    </div>
  );
};
export default Navbar;
